/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to replay pipeline from a given step using refs from a previous execution
 * @export
 * @interface ReplayFromRequest
 */
export interface ReplayFromRequest {
    /**
     * Source execution ID (workflow ID) whose provenance events supply content refs. Required when provenanceEventId is not set.
     * @type {string}
     * @memberof ReplayFromRequest
     */
    sourceExecutionId?: string;
    /**
     * Step to replay from: TRANSFORM or LOAD. Required when provenanceEventId is not set.
     * @type {string}
     * @memberof ReplayFromRequest
     */
    fromStep?: ReplayFromRequestFromStepEnum;
    /**
     * Optional: replay from this single provenance event only. When set, sourceExecutionId and fromStep are derived from the event.
     * @type {string}
     * @memberof ReplayFromRequest
     */
    provenanceEventId?: string;
    /**
     * When true, skip per-mapping load filters during replay transform. Requires integration_instances:update permission.
     * @type {boolean}
     * @memberof ReplayFromRequest
     */
    bypassFilters?: boolean;
}


/**
 * @export
 */
export const ReplayFromRequestFromStepEnum = {
    Transform: 'TRANSFORM',
    Load: 'LOAD'
} as const;
export type ReplayFromRequestFromStepEnum = typeof ReplayFromRequestFromStepEnum[keyof typeof ReplayFromRequestFromStepEnum];


/**
 * Check if a given object implements the ReplayFromRequest interface.
 */
export function instanceOfReplayFromRequest(value: object): value is ReplayFromRequest {
    return true;
}

export function ReplayFromRequestFromJSON(json: any): ReplayFromRequest {
    return ReplayFromRequestFromJSONTyped(json, false);
}

export function ReplayFromRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplayFromRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceExecutionId': json['sourceExecutionId'] == null ? undefined : json['sourceExecutionId'],
        'fromStep': json['fromStep'] == null ? undefined : json['fromStep'],
        'provenanceEventId': json['provenanceEventId'] == null ? undefined : json['provenanceEventId'],
        'bypassFilters': json['bypassFilters'] == null ? undefined : json['bypassFilters'],
    };
}

export function ReplayFromRequestToJSON(json: any): ReplayFromRequest {
    return ReplayFromRequestToJSONTyped(json, false);
}

export function ReplayFromRequestToJSONTyped(value?: ReplayFromRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceExecutionId': value['sourceExecutionId'],
        'fromStep': value['fromStep'],
        'provenanceEventId': value['provenanceEventId'],
        'bypassFilters': value['bypassFilters'],
    };
}

